
        var result = require("!!../../../../node_modules/css-loader/index.js!./email-queue.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/email-queue/email-queue.component.css
// module id = 465
// module chunks = 0